export const ROOT_PATH = "/";
export const LOGIN_PATH = `${ROOT_PATH}login`;
export const PROFILE_PATH = `${ROOT_PATH}profile`;

export const CHAT_PAGE_PATH = `${ROOT_PATH}chat`;

// error
export const PAGE_403_PATH = `${ROOT_PATH}403`;
export const PAGE_404_PATH = `${ROOT_PATH}404`;
export const PAGE_500_PATH = `${ROOT_PATH}500`;

// user
export const USER_LIST_PATH = `${ROOT_PATH}user-list`;
export const ADD_USER_PATH = `${ROOT_PATH}add-user`;
export const EDIT_USER_PATH = `${ROOT_PATH}edit-user`;

// role
export const ROLE_LIST_PATH = `${ROOT_PATH}role-list`;
export const ADD_ROLE_PATH = `${ROOT_PATH}add-role`;
export const EDIT_ROLE_PATH = `${ROOT_PATH}edit-role`;

// static page
export const STATIC_PAGE_LIST_PATH = `${ROOT_PATH}static-page-list`;
export const ADD_STATIC_PAGE_PATH = `${ROOT_PATH}add-static-page`;
export const EDIT_STATIC_PAGE_PATH = `${ROOT_PATH}edit-static-page`;

// site config
export const SITE_CONFIG_LIST_PATH = `${ROOT_PATH}site-config-list`;
export const ADD_SITE_CONFIG_PATH = `${ROOT_PATH}add-site-config`;
export const EDIT_SITE_CONFIG_PATH = `${ROOT_PATH}edit-site-config`;

// banner
export const BANNER_LIST_PATH = `${ROOT_PATH}banner-list`;
export const ADD_BANNER_PATH = `${ROOT_PATH}add-banner`;
export const EDIT_BANNER_PATH = `${ROOT_PATH}edit-banner`;

// whyChooseUs
export const WHYCHOOSEUS_LIST_PATH = `${ROOT_PATH}whyChooseUs-list`;
export const ADD_WHYCHOOSEUS_PATH = `${ROOT_PATH}add-whyChooseUs`;
export const EDIT_WHYCHOOSEUS_PATH = `${ROOT_PATH}edit-whyChooseUs`;

// services
export const SERVICES_LIST_PATH = `${ROOT_PATH}services-list`;
export const ADD_SERVICES_PATH = `${ROOT_PATH}add-services`;
export const EDIT_SERVICES_PATH = `${ROOT_PATH}edit-services`;

// pricing
export const PRICING_LIST_PATH = `${ROOT_PATH}pricing-list`;
export const ADD_PRICING_PATH = `${ROOT_PATH}add-pricing`;
export const EDIT_PRICING_PATH = `${ROOT_PATH}edit-pricing`;

// instructors
export const INSTRUCTORS_LIST_PATH = `${ROOT_PATH}instructors-list`;
export const ADD_INSTRUCTORS_PATH = `${ROOT_PATH}add-instructors`;
export const EDIT_INSTRUCTORS_PATH = `${ROOT_PATH}edit-instructors`;

// contact
export const CONTACT_LIST_PATH = `${ROOT_PATH}contact-list`;

// about
export const ABOUT_LIST_PATH = `${ROOT_PATH}about-list`;
export const ADD_ABOUT_PATH = `${ROOT_PATH}add-about`;
export const EDIT_ABOUT_PATH = `${ROOT_PATH}edit-about`;
// expenseHead

export const EXPENSEHEAD_LIST_PATH = `${ROOT_PATH}expenseHead-list`;
export const ADD_EXPENSEHEAD_PATH = `${ROOT_PATH}add-expenseHead`;
export const EDIT_EXPENSEHEAD_PATH = `${ROOT_PATH}edit-expenseHead`;
// incomeHead

export const INCOMEHEAD_LIST_PATH = `${ROOT_PATH}incomeHead-list`;
export const ADD_INCOMEHEAD_PATH = `${ROOT_PATH}add-incomeHead`;
export const EDIT_INCOMEHEAD_PATH = `${ROOT_PATH}edit-incomeHead`;
// expense

export const EXPENSE_LIST_PATH = `${ROOT_PATH}expense-list`;
export const ADD_EXPENSE_PATH = `${ROOT_PATH}add-expense`;
export const EDIT_EXPENSE_PATH = `${ROOT_PATH}edit-expense`;
// income

export const INCOME_LIST_PATH = `${ROOT_PATH}income-list`;
export const ADD_INCOME_PATH = `${ROOT_PATH}add-income`;
export const EDIT_INCOME_PATH = `${ROOT_PATH}edit-income`;
// group

export const GROUP_LIST_PATH = `${ROOT_PATH}group-list`;
export const ADD_GROUP_PATH = `${ROOT_PATH}add-group`;
export const EDIT_GROUP_PATH = `${ROOT_PATH}edit-group`;
// SLUGS_EXPORTS_AREA
